export default ({
    SHRINK: Symbol(),
})